import {
  InformationPanel,
  PanelSeparator,
  Selectors,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library-native';
import React, {useCallback, useState} from 'react';

import ApplyForCasinoCredit from 'components/ApplyForCasinoCredit';
import ConnectedPaymentInfoModule from 'containers/ConnectedPaymentInfoModule';
import {useDispatch, useSelector} from 'Provider';
import {isWebViewSelector} from 'store/content';
import {AuthActions, LogoutMsg} from 'store/auth/auth.reducer';
import ConnectedBreadCardModule from 'containers/ConnectedBreadCardModule';
import {useBreadSDK} from 'hooks/useBreadSDK';
import {getSigninUrl} from 'utils/signin';
import MFAGate from 'containers/MFAGate';
import {paymentsTabforwardUrl} from 'models/MFA';
import GatedPaymentsModule from 'components/GatedProfilePanels/GatedPaymentsModule';

const ConnectedPaymentsTab = ({setTabToProfile}) => {
  const isRaaSToken = useWidgetState(Selectors.isRaaSTokenSelector) as boolean;
  const isWebView = useSelector(isWebViewSelector);
  const dispatch = useDispatch();
  const [isApplying, setIsApplying] = useState(false);

  const onSignInPress = useCallback(() => {
    const signinUrl = getSigninUrl(
      `forwardUrl=${encodeURIComponent('/rewards/profile?tab=payments')}`
    );
    const _forwardUrl =
      signinUrl === 'LOCAL_SIGNIN_ROUTE'
        ? '/rewards/profile?tab=payments'
        : signinUrl;

    dispatch(
      AuthActions.logout({
        msg: LogoutMsg.LOGOUT,
        forwardUrl: encodeURIComponent(_forwardUrl),
      })
    );
  }, [dispatch]);

  const {apply} = useBreadSDK(true, false);

  const handleApply = useCallback(async () => {
    setIsApplying(true);
    try {
      await apply();
    } catch (error) {
      console.error('Card application failed:', error);
    } finally {
      setIsApplying(false);
    }
  }, [apply]);

  return (
    <>
      <ConnectedBreadCardModule apply={handleApply} isLoading={isApplying} />
      <MFAGate
        forwardUrl={paymentsTabforwardUrl}
        GatedComponent={GatedPaymentsModule}>
        {isRaaSToken || isWebView ? (
          <ConnectedPaymentInfoModule setTabToProfile={setTabToProfile} />
        ) : (
          <InformationPanel
            isSVG={false}
            iconName="exclamation-circle"
            iconSize={{height: 72, width: 72}}
            titleText="Your Session Has Expired"
            upperDescriptionText="Please sign in again to view your account."
            ctaText="Sign-in"
            onCTAPress={onSignInPress}
            hasShadow
            iconIsLight
            iconColor="#D60000"
          />
        )}
      </MFAGate>
      <PanelSeparator />
      <ApplyForCasinoCredit />
    </>
  );
};

export default ConnectedPaymentsTab;
